module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/core-js/library/modules/_is-object.js
// module id = 147
// module chunks = 2